import React, { Suspense, useEffect, useState } from "react";
import "./App.css";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Header from "./components/header/Header";
import routes from "./routes";
import "../src/common/common_css/Common_css.css";
import "../src/common/common_css/Form_Css.css";
import { Spinner } from "react-bootstrap";
import Reports_Generation from "./components/header_components/reports_generation/Reports_Generation";
import Quality_Management from "./components/header_components/quality_management/Quality_Management";
import User_Management_Page from "./components/header_components/user_management_page/User_Management_Page";
import NoAccess from "./components/NoAccess/noaccess";
import { useDispatch, useSelector } from "react-redux";
import { checkTokenValidity, GETAuthLogin } from "./features/auth/Slice";
import { logDOM } from "@testing-library/react";
function App({}) {
  const location = useLocation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.data);
  const active_token = useSelector((state) => state.auth.activetoken);
  const auhtcode = useSelector((state) => state.auth.code);

  useEffect(() => {
    dispatch(GETAuthLogin());
  }, [dispatch]);
  // const checkToken = () => {
  //   dispatch(checkTokenValidity());
  // };
  // useEffect(() => {
  //   checkToken();
  // }, []);

  useEffect(() => {
    dispatch(checkTokenValidity())
      .unwrap()
      .then(() => {
        navigate("/dashboard");
      })
      .catch(() => {});
  }, []);
  useEffect(() => {
    dispatch(checkTokenValidity())
      .unwrap()
      .catch(() => {
        navigate("/");
      });
  }, []);

  useEffect(() => {
    if (auhtcode === 401) {
      navigate("/");
    }
    if (active_token && user.active_token) {
      if (Number(user.active_token) !== Number(active_token)) {
        navigate("/");
      }
    }
  }, [user, active_token, auhtcode]);

  return (
    <>
      <section className="desktop_container">
        {location.pathname !== "/" && <Header />}
        <Suspense
          fallback={
            <div className="pt-3 text-center">
              <Spinner
                animation="grow"
                variant="primary"
                style={{
                  width: "4rem",
                  height: "4rem",
                  color: "#fbca06",
                  background: "#fbca06",
                }}
              />
            </div>
          }
        >
          <Routes>
            {routes.map((route, idx) => {
              return (
                route.element && (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={<route.element />}
                  />
                )
              );
            })}
            <Route
              path="/reports-generation/*"
              element={<Reports_Generation />}
            ></Route>
            <Route
              path="/quality-management/*"
              element={<Quality_Management />}
            ></Route>
            <Route
              path="/user-management/*"
              element={<User_Management_Page />}
            ></Route>

            <Route path="/no-access" element={<NoAccess />} />
          </Routes>
        </Suspense>
      </section>

      <section className="mobile_container">
        <div className="logo">
          <div className="logo_holder">
            <img
              src={process.env.PUBLIC_URL + "/favicon.png"}
              alt="ultimate-logo"
              className="ultimate-logo"
            />
          </div>
        </div>
        <h2>The page you are viewing is not compatible with mobile.</h2>
        <p>
          To access the page, please select the <strong>'Desktop Site'</strong>{" "}
          in the browser menu or use a <strong>desktop/laptop</strong>.
        </p>
      </section>
    </>
  );
}

export default App;
